import { render, staticRenderFns } from "./Editar-agendamento.vue?vue&type=template&id=e48f6544&scoped=true&"
import script from "./Editar-agendamento.vue?vue&type=script&lang=js&"
export * from "./Editar-agendamento.vue?vue&type=script&lang=js&"
import style0 from "./Editar-agendamento.vue?vue&type=style&index=0&id=e48f6544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48f6544",
  null
  
)

export default component.exports